import styled from "styled-components";

export const Container = styled.div``;
export const ServicesWrap = styled.div``;

export const TitleWrap = styled.div`
  padding-top: ${({ theme }) => theme.spacings.spacing_xl};
  padding-bottom: ${({ theme }) => theme.spacings.spacing_xl};

  @media only screen and (max-width: 560px) {
    padding-top: ${({ theme }) => theme.spacings.spacing_sm};
    padding-bottom: ${({ theme }) => theme.spacings.spacing_sm};
  }
`;

export const ViewAllProducts = styled.div`
  font-family: "Montserrat SemiBold";
  font-size: 15px;
  color: ${({ theme }) => theme.colors.prune};
  text-align: center;
  text-decoration: underline;
  padding-top: 3px;
  padding-bottom: 46px;
  cursor: pointer;

  @media only screen and (max-width: 560px) {
    padding-bottom: 19px;
  }
`;

export const SearchSummary = styled.div`
  ${({ theme }) => theme.textStyles.title1};
  text-align: center;
  padding-bottom: ${({ theme }) => theme.spacings.spacing_l};

  @media only screen and (max-width: 768px) {
    font-size: 15px;
  }
  @media only screen and (max-width: 560px) {
    font-size: 12px;
    padding-bottom: 11px;
  }
`;

export const SearchInputWrap = styled.div`
  display: flex;
  justify-content: center;
`;
